export const projects = [
  {
    name: 'App DoIt',
    description:
      'Um app onde você consegue gerenciar seus projetos, podendo criar projetos, concluir e apagar. Possui rotas autenticadas, modais, formulários de cadastro e login, skeletons, input de pesquisa. Totalmente estilzada com o Chakra UI.',
    image: 'App-Doit.png',
    url: 'https://app-doit.vercel.app/',
    gitHub: 'https://github.com/KelvinSilva10/app-Doit',
    techs:
      'ReactJs | TypescriptJs | ChakraUi | Javascript | Rest Api | Context | React Router Dom | React Hook Form | Yup | Axios',
  },
  {
    name: 'Kenzie Hub',
    description:
      'Um app para gerenciar tecnologias que um desenvolvedor possui. Possui rotas autenticadas, modais, formulários de cadastro e login. ',
    image: 'Kenzie-Hub.png',
    url: 'https://react-entrega-kenzie-hub-kelvin-silva.vercel.app/',
    gitHub: 'https://github.com/KelvinSilva10/Kenzie-Hub',
    techs:
      'ReactJs | TypescriptJs | Styled-Components | Javascript | Rest Api | Context | React Router Dom | React Hook Form | Yup | Axios | Toastify',
  },
  {
    name: 'Nu Kenzie',
    description: 'Um app para gerenciamento de finanças.',
    image: 'Nu-Kenzie.png',
    url: 'https://react-entrega-s1-template-nu-kenzie-kelvin-silva10.vercel.app/',
    gitHub: 'https://github.com/KelvinSilva10/Nu-Kenzie',
    techs: 'ReactJs | Javascript | CSS',
  },
  {
    name: 'Project Connect',
    description:
      'Um app em JavaScript Vanilla onde você consegue gerenciar suas empresas, podendo criar empresas, editar e apagar, criar departamentos, adicionar funcionários e etc. Possui rotas autenticadas, modais, formulários de cadastro e login, input de pesquisa e requisições a API.',
    image: 'Project-connect.png',
    url: 'https://react-entrega-s1-template-nu-kenzie-kelvin-silva10.vercel.app/',
    gitHub: 'https://project-connect.vercel.app/',
    techs: 'Javascript Vanilla | CSS | Axios | Toastify',
  },
];
